import Dialog, { DialogProps } from "@mui/material/Dialog";
import { propsWithSx } from "designSystem/styles/style-functions";
import React, { FunctionComponent } from "react";

const paperStyles = {
	borderRadius: 0,
	height: "100%",
	margin: 0,
	maxHeight: "100%",
	maxWidth: "100%",
	overflow: "hidden",
	padding: 0,
	width: "100%",
};

const transparentPaperStyles = {
	background: "transparent",
	...paperStyles,
};
interface FullScreenDialogProps extends Omit<DialogProps, "onResize"> { }

const FullScreenDialog: FunctionComponent<FullScreenDialogProps> = (props) => {
	const { PaperProps, ...otherProps } = props;
	return (
		<Dialog
			PaperProps={propsWithSx(PaperProps, paperStyles)}
			{...otherProps}
		/>
	);
};

export const FullScreenDialogTransparent: FunctionComponent<FullScreenDialogProps> = (props) => {
	const { PaperProps, ...otherProps } = props;
	return (
		<Dialog
			PaperProps={propsWithSx(PaperProps, transparentPaperStyles)}
			{...otherProps}
		/>
	);
};

export default FullScreenDialog;